// Single source of truth for BestSafari's public social profile URLs, so the
// footer links and any future references can't drift apart.

export const SOCIAL_LINKS = [
  {
    platform: "facebook",
    label: "BestSafari.Africa on Facebook",
    href: "https://www.facebook.com/61584492685833/",
  },
  {
    platform: "instagram",
    label: "BestSafari.Africa on Instagram",
    href: "https://www.instagram.com/bestsafari.africa",
  },
] as const;
